module.exports = __webpack_public_path__ + "img/35.bbb9cc53.png";